<ng-template cdkPortal #policy="cdkPortal">
  <div class="terms-conditions">
    <div class="header" *ngIf="config.showHeader">
      <div class="popover-header-container">
        <div class="title" *ngIf="config.showHeaderTitle">
          {{content.header.title}}
        </div>
        <div class="sub-title" *ngIf="config.showHeaderSubTitle">
          {{content.header.subtitle}}
        </div>
      </div>
      <div class="close-popover" (click)="closeOverlay()">
        <i class="fa fa-close"></i>
        <div *ngIf="config.showHeaderCloseText" class="close">
          <span>close</span>
        </div>
      </div>
    </div>
    <div class="popover-body" *ngIf="config.showBodyContent">
      <div class="body-content">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="footer" *ngIf="config.showFooter">
      <div *ngFor="let button of content.buttons" class="mar-t-b-auto">
        <button *ngIf="button.type === 'button'" class="btn-{{button.action}} button" (click)="emitAction(button.action)">{{button.label}}</button>
        <span *ngIf="button.type === 'link'" class="link-{{button.action}} link" (click)="emitAction(button.action)">{{button.label}}</span>
      </div>
    </div>
  </div>
</ng-template>
